module.exports = __webpack_public_path__ + "img/jdid.74a6d72.png";